import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

// containers
import Sidebar from '../../containers/Sidebar';
import Header from '../../containers/Header';
import VehicleSelector from '../../containers/Vehicle';
import Places from '../../containers/Places';
import ReverseBtn from '../../containers/ReverseBtn';
import StartOverBtn from '../../containers/StartOverBtn';
import Directions from '../../containers/Directions';
import CancelBtn from '../../containers/CancelBtn';
import RouteBtn from '../../containers/RouteBtn';
import RouteSummary from '../../containers/RouteSummary';
import GoogleMap from '../../containers/GoogleMap';
import Superchargers from '../../containers/Superchargers';
import EditBtn from '../../containers/EditBtn';
import AddStopBtn from '../../containers/AddStopBtn';
import ErrorMsg from '../../containers/ErrorMsg';

const AppPropTypes = {
  store: PropTypes.shape({
    dispatch: PropTypes.func,
    subscribe: PropTypes.func,
    getState: PropTypes.func,
    replaceReducer: PropTypes.func,
    Symbol: PropTypes.func,
  }).isRequired,
};

const AppDefaultProps = {};

/**
 * @description App component represents entire Tesla Trip Planner application
 */
const App = ({ store }) => (
  <Provider store={store}>
    <div className="trip-planner-app">
      <Sidebar>
        <ErrorMsg />
        <Header />
        <VehicleSelector />
        <Places>
          <ReverseBtn />
          <StartOverBtn />
          <EditBtn />
          <AddStopBtn />
        </Places>
        <Directions />
        <CancelBtn />
        <RouteBtn />
        <RouteSummary />
      </Sidebar>
      <GoogleMap />
      <Superchargers />
    </div>
  </Provider>
);

App.propTypes = AppPropTypes;

App.defaultProps = AppDefaultProps;

export default App;
